import React from 'react'
import { Row } from 'antd'
import { section } from './header-sections'
import { useTranslation } from 'next-i18next'
import { CustomTitle, CustomCol } from 'src/components'
import styles from './IntegrationTransactionListHeader.module.scss'

const IntegrationTransactionListHeader: React.FC<{ quantity: number }> = ({ quantity }) => {
  const { t } = useTranslation()

  return <div className={styles.content}>
    <Row>
      <CustomCol lg={8}>
        <CustomTitle
          type={null}
          className={styles.label}
          label={`${t('developers.TransactionsLog')} (${quantity})`}
        />
      </CustomCol>
      <CustomCol lg={6}>
        <section.IntegrationPurchaseFilter />
      </CustomCol>
      <CustomCol lg={5}>
        <section.OffsetByExcelButton />
      </CustomCol>
      <CustomCol lg={4} xs={21}>
        <section.IntegrationPurchaseDownloadButton />
      </CustomCol>
      <CustomCol lg={1} xs={3}>
        <section.IntegrationPurchasesZipDownloadButton />
      </CustomCol>
    </Row>
  </div>
}

export default IntegrationTransactionListHeader
